import React from "react";
export var AddedToCart = function AddedToCart(e) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, e), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: "#EDF5F1",
    stroke: "#1E824C",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M1.333 26.665L1.333 6.376 23.498 6.376 23.498 26.665z"
  }), React.createElement("path", {
    stroke: "#1E824C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M7.983 10.2V5.765c0-2.448 1.984-4.433 4.433-4.433 2.448 0 4.432 1.985 4.432 4.433V10.2h0"
  }), React.createElement("g", {
    transform: "translate(13.333 13.333)"
  }, React.createElement("circle", {
    cx: "8.667",
    cy: "8.667",
    r: "8.667",
    fill: "#C94557"
  }), React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.716",
    d: "M4 9.173L7.292 12 13.333 6.667"
  }))));
};